import React, {useState, useEffect, useCallback} from 'react';
import Range from 'rc-slider/lib/Range';
import 'rc-slider/assets/index.css';
import PropTypes from 'prop-types';
import {decs, toNum} from '../lib/utils';
import styled, {css} from 'styled-components';

const fullStyles = `
  .rc-slider-vertical {
    .rc-slider-handle {
      margin-left: 0;
      width: 8px;
      height: 8px;
      background-color: #bbb;
    }
  }
  .rc-slider-track {
    background: #222;
  }
  .rc-slider-mark {
    display: none;
  }
`

const StyledFilterRange = styled.div`
  width: 16px;
  height: 80%;
  margin: 0 auto;
  transform: translateY(10%);
  position: relative;
  .rc-slider-step {
    display: none;
  }
  .rc-slider-vertical {
    width: 16px;
    padding: 0 4px;
    background-color: #222;
    border-radius: 8px;
    z-index: 2;
    &::before {
      content: "";
      display: block;
      background-color: #222;
      height: calc(100% + 8px);
      position: absolute;
      width: 16px;
      border-radius: 8px;
      left: 0;
      top: -4px;
    }
    .rc-slider-track {
      width: 8px;
      left: 4px;
    }
    .rc-slider-handle {
      margin-left: 1px;
      width: 6px;
      height: 6px;
      border: none;
      background-color: #222;
      &:focus {
        border-color: none;
        box-shadow: unset;
      }
    }
    .rc-slider-mark {
      transform: translateX(-50px);
    }

    .rc-slider-mark-text {
      right: 0;
      white-space: nowrap;
      pointer-events: none;
      -webkit-touch-callout: none;
      -webkit-user-select: none;
      -khtml-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    .rc-slider-mark-text:first-child {
      line-height: 1.5;
    }

    .rc-slider-mark-text:last-child {
      line-height: 1.5;
    }

    .rc-slider-handle-1 {
      transform: translateY(-25%) !important;
    }
    .rc-slider-handle-2 {
      transform: translateY(125%) !important;
    }
  }
  .rc-slider-rail {
    background-color: #222;
    height: 4px;
    border-radius: 6px;
  }
  .rc-slider-track {
    position: absolute;
    left: 0;
    height: 8px;
    border-radius: 4px;
    padding: 2px 0;
    background: linear-gradient(0deg, #00793A 0%, #65AC1E 100%);
  }
  input[type="number"],
  input[type="text"] {
    border: 0;
    padding: 4px;
    background-color: #222;
    position: absolute;
    right: -75px;
    width: 50px;
    border-radius: 4px;
    height: 24px;
    z-index: 3;
    -moz-appearance: textfield; /* Firefox */
    -webkit-appearance: textfield;
    appearance: textfield;
    text-align: center;
    color: #FFF;
    font-size: 0.75em;
    &:first-of-type {
      top: 0;
      ::-webkit-input-placeholder { /* Edge */
        color: ${props => props.focus === "max" ? `#666` : '#fff'};
      }
      :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: ${props => props.focus === "max" ? `#666` : '#fff'};
      }
      ::placeholder {
        color: ${props => props.focus === "max" ? `#666` : '#fff'};
      }
    }
    &:last-of-type {
      bottom: 0;
      ::-webkit-input-placeholder { /* Edge */
        color: ${props => props.focus === "min" ? `#666` : '#fff'};
      }
      :-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: ${props => props.focus === "min" ? `#666` : '#fff'};
      }
      ::placeholder {
        color: ${props => props.focus === "min" ? `#666` : '#fff'};
      }
    }

  }
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .tiks {
    position: absolute;
    height: 100%;
    top: 0;
    left: 50%;
    width: 30px;
    transform: translateX(-50%);
    > span::before,
    > span::after {
      content: "";
      display: block;
      height: 1px;
      background-color: #222;
      width: 6px;
      position: absolute;
    }
    > span::before {
      left: -3px;
    }
    > span::after {
      right: -3px;
    }
    span {
      &:nth-child(0)::before,
      &:nth-child(0)::after {
        top: 0;
      }
      &:nth-child(1)::before,
      &:nth-child(1)::after {
        top: 25%;
      }
      &:nth-child(2)::before,
      &:nth-child(2)::after {
        top: 50%;
      }
      &:nth-child(3)::before,
      &:nth-child(3)::after {
        bottom: 25%;
      }
      &:nth-child(4)::before,
      &:nth-child(4)::after {
        bottom: 0;
      }
    }
  }
  ${props => props.full ? css`${fullStyles}` : ''}
`;

let int = null;

export default function FilterRange (props) {

  const {data, fix, setFilter} = props;
  const {key, min, max, minTotal, maxTotal, minAvail, maxAvail} = data;
  const maxValue = fix ? max*1000 : max;
  const minValue = fix ? min*1000 : min;
  const maxTotalValue = fix ? maxTotal*1000 : maxTotal;
  const minTotalValue = fix ? minTotal*1000 : minTotal;
  const maxAvailValue = fix ? maxAvail*1000 : maxAvail;
  const minAvailValue = fix ? minAvail*1000 : minAvail;
  const [value, setValue] = useState([]);
  const [minIn, setMinIn] = useState();
  const [maxIn, setMaxIn] = useState();
  const [focus, setFocus] = useState();
  const dec = decs[key];
  const step = fix ? 1 : dec ? 1/(Math.pow(10, dec)) : 1;
  const [mounted, setMounted] = useState(false);

  const updateValues = useCallback((arr) => {
    setMinIn(arr[0]);
    setMaxIn(arr[1]);
    setValue(arr);
  }, []);

  const onInputChange = useCallback((e) => {
    const id = e.currentTarget.name === "range-min" ? "min" : "max";
    const val = toNum(e.currentTarget.value, key);
    const curr = isNaN(val) ? (id === "min" ? value[0] : value[1]) : val;
    const currMin = id === "min" ? curr*(fix ? 1000 : 1) : value[0];
    const currMax = id === "max" ? curr*(fix ? 1000 : 1) : value[1];
    setMinIn(currMin);
    setMaxIn(currMax);
    clearTimeout(int);
    int = setTimeout(() => {
      const currValue = fix ?
        (curr*1000 >= maxTotalValue || curr*1000 <= minTotalValue ?
          (id === "min"
            ? (curr*1000 <= minTotalValue ? minTotalValue : value[0])
            : (curr*1000 >= maxTotalValue ? maxTotalValue : value[1])
          ) : curr*1000
        )
      : (curr >= maxTotalValue || curr <= minTotalValue ?
        (id === "min"
          ? (curr <= minTotalValue ? minTotalValue : value[0])
          : (curr >= maxTotalValue ? maxTotalValue : value[1])
        ) : curr
      );

      const mi = id === "min" ? currValue : value[0];
      const ma = id === "max" ? currValue : value[1];
      updateValues([mi, ma]);
      if(mi <= minTotalValue && ma >= maxTotalValue){
        setFilter(data);
      } else {
        setFilter(data, [fix ? mi/1000 : mi, fix ? ma/1000 : ma]);
      }
    }, 1000);
  }, [minTotalValue, maxTotalValue, value, setFilter, updateValues, fix, key])

  useEffect(() => {
    if(!mounted){
      setMounted(true);
      updateValues([minTotalValue, maxTotalValue])
    } else {
      updateValues([minValue, maxValue]);
    }
  }, [mounted, updateValues, minValue, maxValue, minTotalValue, maxTotalValue]);

  return (
    <StyledFilterRange focus={focus} full={!!(value[0] === minTotalValue && value[1] === maxTotalValue)}>
      <input
        type="text"
        name="range-max"
        defaultValue={fix && maxIn ? maxIn/1000 : maxIn}
        placeholder={fix && maxIn ? maxIn/1000 : maxIn}
        onChange={onInputChange}
        onFocus={e => {setFocus("max"); e.currentTarget.value = null}}
        onBlur={e => {setFocus(""); e.currentTarget.value = null}}
      />
      <Range
        min={minTotalValue}
        max={maxTotalValue}
        defaultValue={[minTotalValue, maxTotalValue]}
        value={value}
        step={step}
        vertical={true}
        pushable={true}
        marks={{[minAvailValue]: `min -`, [maxAvailValue]: `max -`}}
        onChange={updateValues}
        onAfterChange={(value) => {
          const upd = fix ? [value[0]/1000, value[1]/1000] : value
          setFilter(data, upd)
        }}
      />
      <div className="tiks">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <input
        type="text"
        name="range-min"
        defaultValue={fix && minIn ? minIn/1000 : minIn}
        placeholder={fix  && minIn? minIn/1000 : minIn}
        onChange={onInputChange}
        onFocus={e => {setFocus("min"); e.currentTarget.value = null}}
        onBlur={e => {setFocus(""); e.currentTarget.value = null}}
      />
    </StyledFilterRange>
  )
}

FilterRange.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
};
